import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { HowToBuyAccordion } from './HowToBuyAccordion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-brand-cream" data-id="element-86" data-mp="23v1mzfz2bwjs">
      {/* Decorative background elements */}
      <div className="absolute top-1/4 left-10 w-64 h-64 bg-brand-sage-light/30 rounded-full blur-3xl animate-pulse-glow" data-id="element-87" data-mp="28uej6rbtqfz1" />
      <div className="absolute bottom-1/4 right-10 w-80 h-80 bg-brand-beige/50 rounded-full blur-3xl animate-pulse-glow" style={{
      animationDelay: '2s'
    }} data-id="element-88" data-mp="2wm36tudpag9n" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/10 rounded-full blur-[100px] -z-10" data-id="element-89" data-mp="2ms30xqalh6zv" />

      {/* Floating Sparkles */}
      <motion.div className="absolute top-1/3 left-1/4 text-brand-gold/60 animate-float" style={{
      animationDelay: '0s'
    }} data-id="element-90" data-mp="3fgi5fiw3o6wy">
        <Sparkles size={24} data-id="element-91" data-mp="2fgbm74jtgfcx" />
      </motion.div>
      <motion.div className="absolute bottom-1/3 right-1/4 text-brand-sage/50 animate-float" style={{
      animationDelay: '1.5s'
    }} data-id="element-92" data-mp="2bdx2yjc8jdl4">
        <Sparkles size={20} data-id="element-93" data-mp="2p6mpcovoekir" />
      </motion.div>
      <motion.div className="absolute top-1/4 right-1/3 text-brand-gold/40 animate-float" style={{
      animationDelay: '3s'
    }} data-id="element-94" data-mp="2ke3dbwcmzxg2">
        <Sparkles size={16} data-id="element-95" data-mp="2z5c9kob1oh26" />
      </motion.div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 flex flex-col items-center text-center" data-id="element-96" data-mp="2u3d4n9znpc34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto" data-id="element-97" data-mp="382wcs2sgwnff">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm text-brand-sage-dark text-sm font-medium mb-8 soft-glow border border-brand-beige" data-id="element-98" data-mp="18s4zt04obewk">
            <span data-id="element-99" data-mp="3drmk626imh67">Skincare Coreano en Chile</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-serif font-medium text-brand-charcoal leading-tight mb-6 text-balance" data-id="element-100" data-mp="3irim7vvnjyj4">
            Tu piel puede cambiar... <br className="hidden md:block" data-id="element-101" data-mp="3mtvsqmi840gy" />
            <span className="italic text-shimmer" data-id="element-102" data-mp="3mqrjhapwiejf">y tu vida también ✨</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-charcoal/80 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-103" data-mp="3rqcrean1tx8a">
            Skincare coreano premium para transformar tu piel Descubre el poder del ritual con RIMAN.
          </p>

          <div className="flex items-center justify-center" data-id="element-104" data-mp="ac7efd566tqv">
            <a href="https://mall.riman.com/nicolcabello/products/54828?Concern=87,93,94&Line=133&SubCategory=100&Category=5,2" target="_blank" rel="noopener noreferrer" className="btn-sparkle w-full sm:w-auto px-8 py-4 bg-brand-sage text-white rounded-full font-medium hover:bg-brand-sage-dark transition-all transform hover:-translate-y-1 shadow-lg shadow-brand-sage/20 soft-glow-hover" data-id="element-105" data-mp="adif343bjldr">
              Quiero mi Ritual
            </a>
          </div>

          <HowToBuyAccordion data-id="element-106" data-mp="1uurjah4og4sg" />
        </motion.div>
      </div>

      {/* Subtle scroll indicator */}
    </section>;
}